export const no = {
  message: {
    layout: {
      login: 'Logg inn',
      logout: 'Logg ut',
      customers: 'Kunder',
      crm: 'CRM',
      settings: 'Innstillinger',
      timer: 'Time håndtering',
      user: 'Brukere',
      userRole: 'Brukerrolle',
      productType: 'Produkttyper',
      priorities: 'Prioriteringer',
      ticketStatus: 'Sakstatus',
      ticketTypes: 'Sakstype',
      department: 'Avdeling',
      groups: 'Gruppe',
      ticket: 'Ticket',
      mailConfiguration: 'E-post konfigurasjon',
      systemConfiguration: 'Systemkonfigurasjon',
      hse: 'HMS',
      product: 'Produkt',
      products: 'Produkter',
      order: 'Ordre',
      deviation: 'Avvik',
      deviationCategory: 'Avvikskategori',
      deviationLocation: 'Lokasjon',
      deviationStatus: 'Status',
      deviationMeasures: 'Avvikstiltak',
      measureStatus: 'Titaksstatus',
      measureCategory: 'Tiltakskategori',
      deviationSettingStatus: 'Avviksstatus',
      onedriveSetting: 'OneDrive instillinger',
      sharepointSetting: 'Sharepoint instillinger',
      sharepointCredential: 'SharePoint legitimasjon',
      filesFromSharepoint: 'Filer fra Sharepoint',
      noFiles: 'Ingenting funnet!',
      filesAdded: 'Vedlegg: ',
      clearOneDrive: 'Tømme OneDrive',
      category: 'Kategori',
      location: 'Lokasjon',
      loc: 'Lok.',
      priority: 'Prioritet',
      status: 'Status',
      deviations: 'Avvik',
      tickets: 'Saker',
      types: 'Typer',
      sharepoint: 'Sharepoint',
      crmSettings: 'CRM instillinger',
      industries: 'Bransjer',
      shipments: 'Transportører',
      permission: 'Tillatelser',
      currencies: 'Valutakurser',
      salesAccounts: 'Salgskonto',
      productGroup: 'Varegruppe',
      productUnit: 'Produktenhet',
      warehouseSettings: 'Lager innstillinger',
      warehouse: 'Lager',
      warehouseLocations: 'Lagerlokasjon',
      offer: 'Tilbud',
      grossMargin: 'Avanse',
      discountGroups: 'Rabbat grupper',
      discountGroup: 'Rabattgruppe',
      orderOrOffer: 'Tilbud/Ordre',
      salesOrOffer: 'Salg/Tilbud',
      invoiceSettings: 'Faktura innstillinger',
      invoices: 'Faktura',
      dashboard: 'Dashboard',
      reports: 'Rapporter',
      mailAddressFilter: 'Epost filter',
      advanced: 'Avansert',
      sales: 'Salg',
      totalTurnoverPerResponsible: 'Total omsetning per ansvarlig',
      checklist: 'Sjekkliste',
      checklists: 'Sjekklister',
      totalCount: 'Total count',
      show: 'Show'
    },
    login: {
      language: 'Språk',
      back: 'Tilbake',
      userName: 'Brukernavn',
      password: 'Brukerpassord',
      authFailed: 'Godkjenning mislyktes',
      enterUserName: 'Skriv inn brukernavn',
      enterPassword: 'Skriv inn passord',
      enterConfirmPassword: 'Gjenta passord',
      resetNow: 'Nullstill',
      invalidPassword: 'Ugyldig passord',
      unauthorizedMsg: 'Ingen tillatelse',
      forgotPassword: 'Glemt passord?',
      mailNotFound: 'Epostadressen ekisterer ikke',
      linkShared: 'Lenke for tilbakestilling av passord har blitt sendt!',
      office365: 'Logg inn med Office 365',
      or: 'Eller'
    },
    common: {
      order: 'Order',
      english: 'Engelsk',
      norwegian: 'Norsk',
      save: 'Lagre',
      send: 'Send',
      edit: 'Endre',
      cancel: 'Avbryt',
      update: 'Oppdater',
      delete: 'Slett',
      updateAndClose: 'Oppdater og lukk',
      close: 'Lukk',
      new: 'Ny',
      isActive: 'Er aktiv',
      addNew: 'Legg til ny',
      isClosed: 'Is closed',
      closedOn: 'Lukket',
      savedSuccess: 'Lagret',
      addedSucess: 'Opprettet',
      updatedSuccess: 'Oppdatert',
      uploadedSuccess: 'Lastet opp!',
      deleteSuccess: 'Slettet',
      backToList: 'Tilbake',
      exportedSuccess: 'Eksport vellykket !',
      search: 'Søk',
      yes: 'Ja',
      no: 'Nei',
      isDefault: 'Er standard',
      deleteMsg: 'Slettet',
      loadingMsg: 'Laster inn, vennligst vent',
      deleteConfirm: 'Bekreft sletting',
      areYouSure: 'Er du sikker på at du vil slette?',
      validationIssue: 'Vennligst sjekk de obligatoriske feltene!',
      total: 'Totalt',
      noResults: 'Ingen resultater funnet!',
      others: 'Andre',
      typeHere: 'Skriv inn her...',
      position: 'Posisjon',
      color: 'Farge',
      maxCharacters: 'Maks {charCount} tegn',
      changedPassword: 'Passord endret',
      import: 'Importer',
      note: 'Notat',
      invalidEmail: 'Ugyldig e-post',
      no_records: 'Ingen resultater funnet!',
      ok: 'Ok',
      syncedSuccess: 'Synkronisert',
      createMsg: 'Opprettet',
      updateMsg: 'Vellykket oppdatering',
      comment: 'Kommentar',
      comments: 'Kommentarer',
      export: 'Eksport',
      importProducts: 'Importer produkt',
      exportProducts: 'Eksport Products',
      importSuppliers: 'Importer Suppliers',
      importSuccess: 'Importert!',
      days: 'Dager',
      draft: 'Kladd',
      ready: 'Klar',
      sent: 'Sendt',
      accepted: 'Akseptert',
      notAccepted: 'Ikke akseptert',
      createOrder: 'Lag ordre',
      ordered: 'Bestilt',
      inProgress: 'Pågår',
      receiving: 'Mottak',
      received: 'Mottat',
      receivedDate: 'Mottatt dato',
      receive: 'Mottat',
      partiallyReceived: 'Delvis mottat',
      request: 'Forespørsel',
      partiallyPicked: 'Delvis hentet',
      picked: 'Hentet',
      pickedqty: 'Leveres',
      pickQ: 'Plukket',
      high: 'Høy',
      low: 'Lav',
      medium: 'Middels',
      qtyExceeds: 'Antall overskrider',
      difference: 'Forskjellen',
      completedBy: 'Fullført av',
      completedAt: 'Fullført på',
      completed: 'Fullført',
      complete: 'Ferdig',
      ccsheet_warehouse_exists: 'In complete sheets are available for this warehouse/product groups',
      batchExists: 'Batchnummer eksisterer allerede!',
      actionPerformed: 'Vellykket handling',
      receivedOn: 'Mottatt den',
      add_extra_mails: 'Bruk komma for å legge inn flere epost adresser',
      copy_to_me: 'Kopi til meg',
      order_report: 'Bestilling',
      orderConfirm: 'Ordrebekreftelse',
      offerConfirm: 'Tilbud pdf',
      offerWithZone: 'Tilbud totalt p/sone',
      orderConfirmWithData: 'Ordrebekreftelse m/dataark',
      invalidDataFound: 'Ugyldige data funnet!',
      commercialInvoice: 'Commercial Inv.',
      warning: 'Varsel!',
      changes_saved: 'Endringene er ikke lagret',
      are_you_navigate: 'Vil du navigere bort?',
      warning_saved: 'Endringen er ikke lagret',
      save_continued: 'Vil du lagre og fortsette ?',
      information: 'Informasjon',
      both: 'Begge',
      add: 'Legg til',
      status: 'Status',
      multiEmailHint: 'MERK: Vennligst bruk komma (,) for å legge til flere e-post adresser',
      confirmation: 'Bekreftelse',
      no_data: 'Ingen data tilgjengelig',
      noNotes: 'Ingen notater',
      noComments: 'Ingen kommentarer',
      modifiedOn: 'Endret',
      modifiedBy: 'Endret av',
      searchTriggerHint: '(Trykk Enter eller click Søk ikon)',
      startTyping: 'Begynn å skrive for å søke',
      reset: 'Nullstille',
      emailAddress: 'Epostadresse/domene',
      thisweek: 'Denne uka',
      thismonth: 'Denne måned',
      thisyear: 'I år',
      custom: 'Definer',
      month: 'Måned',
      year: 'År',
      week: 'Uke',
      noData: 'Ingenting å vise',
      importFailed: 'Import feilet!',
      dragAndFilesHere: 'Dra og slip filer her eller ',
      clickHere: 'Klikk her',
      uploadFiles: 'for å laste opp',
      change: 'Endre',
      changeLocation: 'Endre lokasjon',
      reload: 'Oppdater',
      invalidMobileno: 'Mobil / Telefon er ugyldig',
      invalidWeekNumber: 'Ukenummer mellom 1 og 53'
    },
    customer: {
      name: 'Navn',
      address: 'Adresse',
      addressType: 'Type',
      country: 'Land',
      post: 'Post',
      city: 'By',
      municipality: 'Kommune',
      phone: 'Telefonnummer',
      email: 'E-post',
      web: 'Nettsted',
      description: 'Beskrivelse',
      addCustomer: 'Legg til kunde',
      updateCustomer: 'Oppdater kunde',
      contacts: 'Kontakter',
      addContact: 'Legg til kontakt',
      updateContact: 'Oppdater kontakt',
      telephone: 'Hjemmenummer',
      mobile: 'Mobilnummer',
      jobTitle: 'Jobb',
      addAddress: 'Legg til adresse',
      updateAddress: 'Oppdater adresse',
      postbox: 'Postboks',
      postCode: 'Postnummer',
      latitude: 'Breddegrad',
      longitude: 'Lengdegrad',
      coordinates: 'Koordinater',
      isStandard: 'Er standard',
      standard: 'Standard',
      receiveCertificate: 'Skal motta sertifikat',
      customerOrSupplier: 'Kunde/Leverandør',
      activeOrInactive: 'Aktiv/Inaktiv',
      active: 'Aktiv',
      Inactive: 'Inaktiv',
      status: 'Status',
      priority: 'Prioritet',
      buyingCustomer: 'Kjøpende kunde',
      potentialCustomer: 'Potensiell kunde',
      vat: 'Orgnr',
      vatValue: 'MVA',
      vatId: 'MVA kode',
      homepage: 'Hjemmeside',
      visit: 'Besøk',
      delivery: 'Levering',
      installed: 'Installert',
      invoice: 'Faktura',
      iscustomer: 'Er kunde',
      fetchingAddress: 'Vennligst vent mens vi henter adressen...',
      usebaseprices: 'Bruk nettopriser',
      issupplier: 'Er leverandør',
      state: 'Status',
      sg: 'Factoring',
      direct: 'Direkte',
      ehf: 'EHF',
      pdf: 'PDF',
      paymentmethod: 'Betaling',
      invoicetype: 'Fakturatype',
      industry: 'Bransje',
      shipment: 'Transportør',
      shipmentReport: 'Forsendelsesmåte',
      shipmentPurchase: 'Sendemåte',
      accountnumber: 'Kontonummer',
      addSalesAccount: 'Legg til salgskonto',
      updateSalesAccount: 'Oppdater salgskonto',
      norwegianLoc: 'Norsk',
      foreign: 'Utenlandsk',
      addons: 'Tillegg',
      noProductGroupsFound: 'Ingen produktgrupper funnet!',
      productGroup: 'Produktgruppe',
      notificationEmail: 'E-post varsel',
      invoiceEmail: 'Faktura epost',
      organizationNumber: 'Organisasjonsnummer',
      customerNumber: 'Kundenr.',
      mainSupplier: 'Hovedleverandør',
      secondarySupplier: 'Tillegsleverandør',
      priceList: 'Prisliste',
      exists: 'Kunde er allerede registrert',
      customerGroup: 'Kundegruppe',
      validUntil: 'Gyldig til',
      productionAllowed: 'Kan ha produksjonsordre',
      twentyFourSeven: '24seven',
      noSupplier: 'Leverandør ikke valgt',
      createdOn: 'Opprettet',
      updatedOn: 'Sist endret'
    },
    user: {
      firstName: 'Fornavn',
      lastName: 'Etternavn',
      addUser: 'Legg til bruker',
      updateUser: 'Oppdater bruker',
      email: 'E-post',
      mobile: 'Mobilnummer',
      role: 'Rolle',
      pin: 'PIN-kode',
      addRole: 'Legg til brukerrolle',
      updateRole: 'Oppdater brukerrolle',
      profile: 'Profil',
      undo: 'Angre',
      clear: 'Tøm',
      sendMailNotify: 'Ønsker å få varsel fra ticket system',
      externalEmployeeCode: 'Ekstern ansattkode',
      group: 'Gruppe',
      signature: 'Din underskrift'
    },
    warehouse: {
      stock: 'Beholdning',
      order: 'Bestillinger',
      orderRepo: 'Bestilling',
      ccsheet: 'Varetelling',
      product: 'Produkt',
      productName: 'Produkt navn',
      addWarehouse: 'Legg til lager',
      updateWarehouse: 'Oppdater lager',
      addLocation: 'Legg til lagerlokasjon',
      updateLocation: 'Oppdater lagerlokasjon',
      warehouseSync: 'Synk til Shopbox & Opencart',
      openStructure: 'Åpent struktur',
      openOrders: 'Åpne ordre',
      lowStockProposal: 'Lav beholdning',
      lowStockTitle: 'Varer med lav beholdning',
      warningAboutOrder: 'Vil du opprette leverandørordre med valgte produkter?',
      createAndEmail: 'Opprett og send epost',
      createOnly: 'Opprett ordre',
      createOrder: 'Opprett ordre',
      ordersCreatedSuccess: 'Ordre opprettet!',
      drawing: 'Tegning',
      addPackageOrContent: 'Vil du legge til stukturvare eller innhold?',
      contents: 'Legg til innhold',
      quickChangeLocation: 'Endre lokasjon',
      partial: 'Delvis',
      full: 'Full',
      quick: 'Enkeltvare',
      inProduction: 'I produksjon',
      notAValidLocation: 'Lokasjon er ikke gyldig!',
      warehouseExists: 'Lager allerede opprettet!',
      suggested: 'Forslag',
      moveProduct: 'Flytt vare',
      changeDefaultLoc: 'Bytt standard lokasjon',
      showAllLocations: 'Vis alle lokasjoner med beholdning for plukk'
    },
    order: {
      productNotFound: 'Produkt ikke funnet',
      orderdocuments: 'Ordredokumenter',
      orderdetails: 'Ordredetaljer',
      customer: 'Kunde',
      startDate: 'Start dato',
      endDate: 'Slutt dato',
      bas: 'Gruppeleder',
      manager: 'Leder',
      date: 'Dato',
      deliveryDate: 'Lev.dato',
      pickedDate: 'Plukket',
      deliveredQty: 'Levert',
      shippingDate: 'Forsendelsesdato',
      contactPerson: 'Kontaktperson',
      yourContactPerson: 'Deres kontaktperson',
      contactPhone: 'Deres telefonnummer',
      updatedOn: 'Oppdatert på',
      details: 'Detaljer',
      lines: 'Linjer',
      documents: 'Dokumenter',
      summary: 'Oppsummering',
      orderName: 'Ordrenavn',
      offerNumber: 'Tilbudsnummer',
      orderNumber: 'Ordrenummer',
      statusName: 'Status navn',
      paymentTerm: 'Betalingsfrist',
      deliveryTerm: 'Leveringsbetingelser',
      paymentDate: 'Betalingsdato',
      agentName: 'Forhandlernavn',
      customerReference: 'Kundereferanse',
      deliveryCondition: 'Leveringsbetingelse',
      customerContactPerson: 'Kundekontaktperson',
      deadlineDate: 'Frist dato',
      notes: 'Merknader',
      netprice: 'Nettopris',
      estimatedhourscost: 'Estimerte kost per time',
      estimatedtotalcosts: 'Estimerte totale kostnader',
      actualhourscost: 'Faktiske timer kostnader',
      actualtotalcosts: ' Faktiske totale kostnader',
      totalCost: 'Totalt Kost',
      estimatedcontributionmargin: 'Estimert bidragsmargin',
      estimatedcontributionmarginratio: 'Estimert marginalgrad',
      actualcontributionmargin: 'Faktisk bidragsmarginal',
      actualcontributionmarginratio: 'Faktisk marginalgrad',
      plannedhours: 'Planlagte timer',
      plannedservedhours: 'Planlagte serverte timer',
      plannedprogress: 'Planlagt fremgang',
      actualhours: 'Faktiske timer',
      actualservedhours: 'Faktiske serverte timer',
      actualprogress: 'Faktisk fremgang',
      noSummariesFound: 'Ingen sammendrag funnet!',
      qty: 'Stk',
      height: 'Høyde',
      customername: 'Kundenavn',
      unitprice: 'Enhetspris',
      measureunit: 'Mål enhet',
      totalnetprice: 'Total nettopris',
      totalprice: 'Totalpris',
      actualplandate: 'Faktisk plandato',
      actualstartdate: 'Faktisk startdato',
      actualenddate: 'Faktisk sluttdato',
      certificate: 'Sertifikat',
      supplier: 'Leverandør',
      batchNumber: 'Batchnummer',
      article: 'Artikkel',
      download: 'Nedlasting',
      share: 'Dele',
      emailNote: 'Bruk komma (,) for å legge til flere e-post-ID-er',
      searchByBatchNumber: 'Søk etter batchnr',
      showOrderRequire: 'Vis ordre som krever sertifikat',
      recreateCertificate: 'Gjenopprette sertifikat',
      syncNow: 'Synkroniser nå',
      sendToCustomer: 'Send til kunde',
      sendToDefined: 'Send til definerte',
      batchNo: 'Batchnr.',
      myOrder: 'Mine bestillinger',
      order: 'Bestillinger',
      unableToDelete: 'Kan ikke slette!',
      orderBillingData: 'Grunnlag',
      orderOffer: 'Tilbud/Ordre',
      myTasks: 'Mine oppgaver',
      offerAccepted: 'Tilbud er bekreftet og ny ordre blir opprettet. Vil du fortsette?',
      orderedQtyHigh: 'Antall mottatt er høyere enn bestilt, vil du fortsette?  ( Ja / Nei )',
      paymentTerms: 'Bet. betingelser',
      totalVAT: 'Totalt mva',
      rest: 'Rest',
      asMainSupplier: 'Hoved leverandør',
      approval: 'Godkjenning',
      approveSelected: 'Godkjenn valgte',
      reverseApproval: 'Fjern godkjenning',
      purchase: 'Innkjøp',
      supplierOrderCreationText: 'Vil du opprette innkjøp for skaffevarer?',
      allProducts: 'Alle varer',
      lowOnStock: 'Lav lagerbeholdning',
      searchLocation: 'Fin lokasjon',
      productsNotPicked: 'Ordre er ikke plukket ferdig. Hva vil du gjøre?',
      invoiceWithRest: 'Faktura med restordre',
      invoiceWithoutRest: 'Faktura uten restordre',
      productionOrder: 'Produksjon',
      kilabOrder: 'Kilab ordre',
      sendOrderConfirmation: 'Send ordrebekreftelse',
      sendOffer: 'Send tilbud',
      sendOrder: 'Send ordre',
      sendSales: 'Send Salgs',
      sendInvoice: 'Send faktura',
      sendCredit: 'Send kreditnota',
      pickOrder: 'Plukk ordre',
      toBePicked: 'Til plukk',
      productsPickedSuccessfully: '{count} produkter plukket!',
      noProductsFoundForPicking: 'Ingenting å plukke!',
      invoiceDeliveryAddress: 'Fakturaadresse',
      last: 'Last',
      supplierOnOrder: 'Leverandør valg på ordre',
      supplierNotSelected: 'Velg leverandør',
      purchaseList: 'Ordreplan',
      orderlist: 'Ordreplan',
      notStockItem: 'Skaffevare',
      exportToExcel: 'Grunnlag til Excel',
      confirmationWithZone: 'Ordrebekreftelse totalt p/sone',
      sureToUndo: 'Vil du angre plukk av {qty} stk {product_number}?',
      stockRevered: 'Varer er tilbakeført til lager!',
      salesOrder: 'Salgsordre',
      labeled: 'Merket',
      probability: 'Sannsynlighet',
      productPrice: 'Produkt pris',
      orderCreated: 'Ordre opprettet',
      noOrder: 'Uten ordre',
      createOrder: 'Opprett ordre',
      cannotCreateOrderWithChildRows: 'Cannot create order with child rows',
      noValidRowsForOrder: 'No valid rows found to create order!',
      orderCreatedSuccessfully: 'Order created successfully!',
      errorOccurred: 'Error occurred!'
    },
    certificate: {
      create: 'Opprett',
      reCreate: 'Generer på nytt'
    },
    document: {
      title: 'Dokument',
      codename: 'Kodenavn',
      datecreated: 'Opprettet',
      documentnumber: 'Nummer',
      text: 'Tekst',
      cost: 'Kost',
      statusdate: 'Status dato',
      versionHistory: 'Versjonshistorikk',
      versionLabel: 'Versjonsetikett',
      size: 'Størrelse',
      versioningDocuments: 'Dokument versjoner',
      builder: 'Dokumentmaler',
      module: 'Module',
      firstPageContent: 'Innhold første side',
      addReport: 'Legg til dokument',
      updateReport: 'Oppdater dokument',
      chooseTemplate: 'Velg mal',
      copyDocuments: 'Kopier dokumenter',
      submit: 'Lagre',
      copy: 'Kopier',
      quickReport: 'Hurtigrapport',
      downloadOnly: 'Kun nedlasting',
      downloadSave: 'Lagre og last ned',
      onlySave: 'Kun lagring',
      loadFromRoot: 'Last inn fra rota',
      copiedMsg: 'Copied successfully'
    },
    template: {
      add: 'Legg til mal',
      update: 'Oppdater mal',
      templates: 'Maler',
      sharepointFields: 'Sharepoint egenskaper (Tittel: Plassholder)',
      moduleFields: 'Modul egenskaper (Tittel: Plassholder), basert på valgt modul',
      placeholderUsageMessage: 'Bruk plassholdere i dokumenter med {} rundt. For eksempel {Author}'
    },
    product: {
      addAtleastOneUnit: 'Legg til minst én enhet og én leverandørenhet',
      addProduct: 'Legg til produkt',
      updateProduct: 'Oppdater produktet',
      number: 'Nummer',
      numberBarcode: 'Number barcode',
      shortName: 'Kort navn',
      unit: 'Enhet',
      units: 'Enheter',
      qty: 'Ant',
      minQty: 'Min.ant.',
      salesUnit: 'Salgsenhet',
      orderUnit: 'Order unit',
      packageQty: 'Package qty',
      monthUsage: '12m forbruk',
      supplier: 'Leverandør',
      ean: 'EAN',
      length: 'Lengde (m)',
      width: 'Bredde (m)',
      thickness: 'Tykkelse (m)',
      weight: 'Nettovekt',
      grossWeight: 'Bruttovekt',
      netweightTotal: 'Nettovekt totalt',
      grossweightTotal: 'Bruttovekt totalt',
      certificateReq: 'Sertifikat kreves',
      type: 'Type',
      image: 'Bilde',
      ignoreDiscount: 'Ignorer rabatt',
      measureUnit: 'Mål enhet',
      radius: 'Radius (mm)',
      minLength: 'Min lengde (m)',
      minWidth: 'Min bredde (m)',
      minHeight: 'Min høyde',
      minThickness: 'Min tykkelse (m)',
      maxLength: 'Maks lengde (m)',
      maxWidth: 'Maks bredde (m)',
      maxHeight: 'Maks høyde',
      maxThickness: 'Maks tykkelse (m)',
      area: 'Areal',
      supplierName: 'Leverandør navn',
      supplierNo: 'Lev.nr.',
      articleNumber: 'Lev. Varenr.',
      articleName: 'Varenavn',
      isStockItem: 'Lagervare',
      isNotInventoryItem: 'Untatt lagerstyring',
      grossMargin: 'Avanse %',
      minStock: 'Min lager',
      maxstockqty: 'Maks stk antall',
      restockqty: 'Restock stk',
      deliveryDays: 'Leveringsdager',
      deleteImage: 'Slett bilde',
      addProductGroup: 'Legg til produktgroup',
      updateProductGroup: 'Oppdater produktgroup',
      costs: 'Kostnader',
      taskName: 'Oppgavenavn',
      hours: 'Timer',
      netCostPrice: 'Netto kostpris',
      additionalCostPer: 'Tilleggskostnadsprosent',
      currencyExchange: 'Valutakurs',
      costPrice: 'Innkjøpspris',
      salePrice: 'Salgspris',
      salePriceExVat: 'Salgspris u/mva',
      salePriceIncVat: 'Salgspris m/mva',
      addSupplierItem: 'Legg til leverandørvare',
      updateSupplierItem: 'Oppdater leverandørvare',
      discount: 'Rabatt',
      addBatchNumber: 'Legg til batchnummer',
      updateBatchNumber: 'Oppdater batchnummer',
      work: 'Arbeid',
      prices: 'Prisene',
      priceValidFrom: 'Gyldig fra',
      salesAccount: 'Salgskonto',
      stocks: 'Beholdning',
      available: 'Tilgjengelig',
      orderQty: 'Best. ant.',
      measures: 'Mål',
      suppliers: 'Leverandører',
      supplierPrice: 'Veiledende pris',
      supplierDiscount: 'Rabatt %',
      discounted: 'Rabattert',
      shipmentAddon: 'Frakt tillegg',
      other: 'Annet tillegg',
      currency: 'Valuta',
      realCost: 'Kostpris',
      realCostNOK: 'Kostpris (NOK)',
      isMain: 'Er hoved',
      isPackage: 'Struktur',
      packageProducts: 'Pakkeprodukter',
      shipment: 'Frakt %',
      other_per: 'Annet %',
      batchRequired: 'Batch',
      barcode: 'Strekkode',
      attachments: 'Vedlegg',
      file: 'Filer',
      chooseFile: 'Velg fil',
      batches: 'Batch',
      batchNumber: 'Batchnummer',
      printLbl: 'Skriv ut etikket',
      reportIsReady: 'Report blir generert. Den vil bli sendt til din epost når den er klar.',
      print: 'Skriv ut',
      selectPreferredSize: 'Velg ønsket størrelse',
      exportMsg: 'Eksport fil blir generert. Den vil bli sendt til din epost når den er klar.',
      salesPrice: 'Salgspris',
      basePrice: 'Nettopris',
      productWithSameNumberExists: 'Produktnummer er allerede tatt, vennligst bruk annet!',
      priceAdj: 'Pris just.',
      adjustByIn: 'Juster med i %',
      dateFrom: 'Gjelder fra',
      priceAdjustments: 'Pris justering',
      priceHistory: 'Pris historikk',
      wayOfUpdate: 'Opdatert',
      by_direct_update: 'Direkte',
      by_mass_adjust: 'Massejustering',
      by_import: 'Import',
      priceAdjustmentAdded: 'Prisjustering er lagt til og vil være aktiv fra valgt dato.',
      exportAllData: 'Eksporter alt',
      importAllData: 'Importer alt',
      exportSupplierPrices: 'Eksporter lev. priser',
      importSupplierPrices: 'Importer lev. priser',
      supplierPriceAdjustment: 'Lev. prisjustering',
      leadTime: 'Lev. tid (dager)',
      package: 'Struktur',
      supplierUnit: 'Lev. enhet',
      addPackage: 'Legg til vare/stykkliste',
      production: 'Prod.vare',
      numberSearch: 'Søk på nummer',
      nameSearch: 'Søk på navn',
      isInformation: 'Infolinje',
      defaultLocation: 'Standard lokasjon',
      typeOfOther: 'Type Annet',
      typeOfShipment: 'Type Frakt'
    },
    priority: {
      addPriority: 'Legg til rabattgruppe',
      updatePriority: 'Oppdater rabattgruppe'
    },
    ticketStatus: {
      addTicketStatus: 'Legg til ticket status',
      updateTicketStatus: 'Oppdater ticket status',
      canClose: 'Kan lukkes'
    },
    ticketCategory: {
      addTicketCategory: 'Ny ticket kategori',
      updateTicketCategory: 'Rediger ticket kategori'
    },
    group: {
      addGroup: 'Legg til gruppe',
      updateGroup: 'Oppdater gruppe',
      addDiscountGroups: 'Ny rabbat gruppe',
      updateDiscountGroups: 'Endre rabbat grupper'
    },
    tickets: {
      createTicket: 'Opprett ticket',
      updateTicket: 'Oppdater ticket',
      createType: 'Opprett Type',
      updateType: 'Oppdater Type',
      merge: 'Slå sammen',
      ticketMerge: 'Slå sammen ticket',
      chooseParentTicket: 'Velg overordnet ticket',
      changeStatus: 'Endre status',
      changePriority: 'Endre prioritet',
      changeAssignedTo: 'Endre tildelt til',
      assignTo: 'Tildele til',
      delete: 'Slett',
      actions: 'Handlinger',
      mailbox: 'Postkasse',
      assignedTo: 'Tildelt til',
      unread: 'Ulest',
      number: 'Nummer',
      status: 'Status',
      type: 'Type',
      tags: 'Merker',
      priority: 'Prioritet',
      from: 'Fra',
      subject: 'Emne',
      createdOn: 'Opprettet den',
      created: 'Opprettet',
      to: 'Til',
      cc: 'Kopi',
      bcc: 'Blindkopi',
      deleteConfirm: 'Er du sikker på at du vil slette disse tickets?',
      deleteNote: 'Å velge dette vil slette e-postene',
      selectTickets: 'Velg tickets',
      sentSuccess: 'Epost sendt!',
      mergeSuccess: 'Slått sammen',
      body: 'Hoveddel',
      note: 'Notat',
      deleteMailsTo: 'Slette e-poster også?',
      all: 'Alle',
      notAssigned: 'Ikke tildelt',
      addTicketType: 'Legg til ticket ype',
      updateTicketType: 'Endre ticket type',
      addPriority: 'Ny prioritet',
      updatePriority: 'Oppdater prioritet',
      lastModified: 'Sist endret',
      assignedtoMessage: 'Du er tildelt',
      by: 'av',
      awb: 'AWB',
      notes: 'Notater',
      personalNotes: 'Egne notater',
      addComments: 'Ny kommentar',
      createTask: 'Ny oppgave',
      description: 'Beskrivelse',
      allTickets: 'Alle ticket',
      myOpenTickets: 'Mine åpne',
      myTickets: 'Mine ticket',
      unassignedTickets: 'Ikke tildelt',
      allActive: 'Alle aktive',
      com: 'Kom.',
      selectAWB: 'Velg AWB',
      noUser: 'Sak er ikke tildelt. Vil du tildele til aktiv bruker?',
      closed: 'Lukket',
      tasks: 'Oppgaver',
      convertToTicket: 'Konverter til sak',
      convertToTask: 'Ny oppgave',
      createOffer: 'Nytt tilbud',
      signature: 'Ticket signatur',
      dontSendAutoreply: 'Ikke send autosvar',
      dontSendNotification: 'Ikke send varsling',
      isOpen: 'Er åpen',
      canReOpen: 'Kan åpne på nytt',
      daysToNotify: 'Dager til varsling om ingen status endring',
      isDomain: 'Is domain',
      autoAssignTicketStatus: 'Auto assign status',
      autoAssignTicketUser: 'Auto assign user',
      addAutoassignStatus: 'Add auto assign status',
      updateAutoassignStatus: 'Update auto assign status',
      addAutoassignUser: 'Add auto assign user',
      updateAutoassignUser: 'Update auto assign user',
      groupOrUser: 'Gruppe eller bruker',
      is: 'inneholder',
      fromAddress: 'From address',
      toAddress: 'To address',
      updateFilter: 'Update address filter',
      addFilter: 'Add address filter',
      noUserAssigned: 'No user has been assigned to this ticket. Would you like to set the active user as assigned to?',
      lastReceivedorsent: 'Sist mottatt/sendt',
      for: 'For',
      customerSet: 'Velg kunde',
      customerChanged: 'Kunde endret fra',
      categorySet: 'Kategori satt til',
      categoryChanged: 'Kategori endret fra',
      sureToChangeStatus: 'Are you sure want to change status ?',
      statusSet: 'Set status',
      statusChanged: 'Status changed from',
      prioritySet: 'Endre prioritet',
      priorityChanged: 'Prioritet endret fra',
      latestContentFound: 'Newly assigned tickets are available!',
      refreshTickets: 'Refresh tickets'
    },
    mailConfiguration: {
      name: 'Navn',
      host: 'Vert',
      port: 'Port',
      usessl: ' UseSsl',
      username: 'Brukernavn',
      password: 'Passord',
      dosync: 'Synkronisering aktiv',
      syncfrom: 'Synkroniser fra dato',
      synctime: 'Synkroniser tid',
      lastsynced: 'Sist synkronisert',
      signature: 'Mailunderskrift',
      addMailConfig: 'Legg til postkonfigurasjon',
      updateMailConfig: 'Oppdater postkonfigurasjon',
      testConnection: 'Testforbindelse',
      connectionSuccess: 'Test vellykket',
      connectionFail: 'Test mislyktes',
      action: 'Handling'
    },
    systemConfiguration: {
      ticketterm: 'Billettperiode',
      enableawb: 'Aktiver #AWB',
      syncinterval: 'Synkroniseringsintervall (minutter)',
      systemConfig: 'Ticketing konfigurasjon',
      ticketCreation: 'Ticket autosvar'
    },
    deviations: {
      title: 'Tittel',
      location: 'Lokasjon',
      category: 'Kategori',
      estimate_cost: 'Estimert kostnad',
      estimatedInternalCost: 'Estimert intern kostnad',
      estimatedCustomerCost: 'Estimert kunde kostnad',
      internalCost: 'Intern kostnad',
      customerCost: 'Kunde kostnad',
      deviationReport: 'Deviation report',
      severity: 'Alvorlighetsgrad',
      addDeviation: 'Legg til avvik',
      updateDeviation: 'Oppdater avvik',
      reported_by: 'Rapportert av',
      reason: 'Årsak',
      underlying_reason: 'Underliggende årsak',
      corrective_actions: 'Korrigerende tiltak',
      effective_of_measures: 'Effekt av tiltak',
      responsible: 'Ansvarlig',
      copy_to: 'Kopier til',
      created_on: 'Opprettet',
      date: 'Dato',
      deadline: 'Frist',
      deviationcategories: 'Avvikskategorier',
      locationtype: 'Plasseringstype',
      printChart: 'Skriv ut diagram',
      downloadPNG: 'Last ned PNG',
      downloadJPEG: 'Last ned JPEG',
      downloadPDF: 'Last ned PDF',
      downloadSVG: 'Last ned SVG',
      statistics: 'Statistikk',
      deviation_report: 'Avviksrapport',
      incharge: 'Ansvarlig',
      filter: 'Filter',
      deadlineFrom: 'Frist fra',
      deadlineTo: 'Frist til',
      addMeasures: 'Nytt tiltak',
      updateMeasures: 'Oppdater tiltak',
      measures: 'Tiltak',
      genertate_pdf_with_attachment: 'Last ned pdf med vedlegg',
      registert: 'Registert',
      openMeasureExists: 'Avvik kan ikke lukkes når minst et tiltak er åpen',
      measureExists: 'Kan ikke lukke avvik. Minst 1 tiltak må være opprettet.',
      categories: 'Kategorier',
      openedDeviation: 'Aktive avvik',
      searchForSupplier: 'Search for supplier'
    },
    severity: {
      select: 'Velg alvorlighetsgrad',
      low: 'Lav',
      medium: 'Medium',
      high: 'Høy'
    },
    hse: {
      hseSystem: 'HMS-SYSTEM',
      uploadDocument: 'Last opp dokument',
      gettingFolders: 'Henter mapper fra SharePoint .... Vent litt ...',
      noDocuments: 'INGEN DOKUMENTER FUNNET!',
      noFolders: 'INGEN MAPPER FUNNET!',
      createNew: 'Opprett mappe',
      editName: 'Rediger mappe',
      deleteFolder: 'Slett mappe',
      upload: 'Laste opp',
      folderName: 'Mappenavn',
      files: 'Filer',
      noResponsible: 'Ingen ansvarlige',
      noDescription: 'Ingen beskrivelse',
      updateMetaData: 'Oppdater metadata',
      openNewTab: 'Åpne i ny tab',
      editMeta: 'Rediger meta'
    },
    deviationSettings: {
      addCategory: 'Legg til avvikskategori',
      updateCategory: 'Oppdater avvikskategori',
      addStatus: 'Legg til avviksstatus',
      updateStatus: 'Oppdater avviksstatus',
      addLocation: 'Legg til avviksplassering',
      updateLocation: 'Oppdater avviksplassering'
    },
    datestrings: {
      year: 'År',
      today: 'I dag',
      month: 'Måned',
      quarter: 'Quarter',
      previousMonth: 'Previous month',
      lastMonth: 'Last {month} month(s)'
    },
    onedriveSettings: {
      oneDriveSetup: 'Konfigurer grunnmappene for HMS og produkter.',
      selectHse: 'Velg HMS-grunnmappe',
      selectProduct: 'Velg produkt grunnmappe',
      selectCustomer: 'Velg kundebase',
      selectDeviation: 'Velg Deviation base',
      odLink: 'OneDrive link'
    },
    sharepointSettings: {
      baseUrl: 'Basis url',
      siteUrl: 'Nettadresse',
      listName: 'Listenavn',
      loadFolders: 'Last inn mapper',
      loadList: 'Last Liste',
      propertiesConfig: 'Egenskaper konfigurasjon',
      contentType: 'Innholdstype',
      configureSharepointCreds: 'Vennligst logg inn på Sharepoint!',
      changeUser: 'Change user',
      sharepointAlertMsg: 'The account used here to login will be considered as System User ({userName})',
      config: 'Sharepoint konfigurasjoner'
    },
    shipment: {
      addShipment: 'Legg til forsendelse',
      updateShipment: 'Oppdater forsendelse',
      bring: 'Bring',
      tnt: 'TNT',
      postnord: 'Postnord'
    },
    industry: {
      addIndustry: 'Legg til industri',
      updateIndustry: 'Oppdater industri'
    },
    permissions: {
      manageShifts: 'Håndter vaktskift',
      manageOpencartOrders: 'Håndter opecart ordrer',
      manageShopboxOrders: 'Håndter shopbox ordrer',
      manageSettings: 'Håndter innstillinger'
    },
    currency: {
      addCurrency: 'Legg til valuta',
      updateCurrency: 'Oppdater valuta',
      exchangeRate: 'Vekslingskurs',
      validFrom: 'Gyldig fra',
      currencyHistories: 'Valutahistorikk'
    },
    unit: {
      addUnit: 'Legg til produktenhet',
      updateUnit: 'Oppdater produktenhet'
    },
    whOrder: {
      orderedQty: 'Best. ant.',
      unitCost: 'Enhetskostnad',
      supplierOrder: 'Innkjøpsordre',
      adjustmentOrder: 'Justeringsordre',
      returnOrder: 'Returordre',
      transferOrder: 'Overføringsordre',
      addSupplierOrder: 'Ny innkjøpsordre',
      updateSupplierOrder: 'Rediger innkjøpsordre',
      addAdjustmentOrder: 'Ny justeringsordre',
      updateAdjustmentOrder: 'Rediger justerings ordre',
      addReturnOrder: 'Add Returordre',
      updateReturnOrder: 'Update Returordre',
      addTransferOrder: 'Ny overføringsordre',
      updateTransferOrder: 'Rediger overføringsordre',
      orderType: 'Ordretype',
      from: 'Fra',
      to: 'Til',
      orderDate: 'Bestillingsdato',
      estimated: 'Estimert',
      requested: 'Ønsket lev.dato',
      estimateDelivery: 'Estimert/Leverings dato',
      comments: 'Melding til leverandør',
      internalComments: 'Intern notat',
      internalCom: 'Intern kommentar',
      warehouseCom: 'Lager kommentar',
      withLocations: 'M/lokasjoner',
      withoutLocations: 'U/lokasjoner',
      confirmed: 'Bekreftet dato',
      pickFiles: 'Velg fil',
      orderQty: 'Bestilt',
      recQty: 'Antall mottatt',
      productNotAvailbleMsg: 'Produktet er ikke tilgjengelig i lokasjonen',
      onstockLessMsg: 'Antall skal ikke være mindre enn lager',
      orderedQtyLessMsg: 'Plukket antall kan ikke overstige bestilt.',
      sameProductMsg: 'Velg en annen produkt',
      minQty: 'Min.ant.',
      availQty: 'Tilgj.',
      sourceWH: 'Fra lager',
      destinationWH: 'til lager',
      pickQty: 'Hentet antall',
      loc: 'Loc',
      ordQty: 'B.ant.',
      batch: 'Batch',
      noLoc: 'Ingen',
      orderProposal: 'Bestillingsforslag',
      qtySame: 'Rec.qty should be same as ordered qty',
      reserved: 'Reservert',
      allData: 'All data',
      supplierPrices: 'Leverandør priser',
      expireDate: 'Expiry date',
      receiveAll: 'Motta alt',
      avail: 'Tilgj.',
      deliverTo: 'Levering til',
      leaveBlank: 'La stå blank hvis levering til',
      withPrices: 'Med priser',
      emailSentTo: 'Epost sendt til {email}, av {user} den {date}',
      labeled: 'Merket',
      ourContact: 'Vår kontakt',
      discount: '% Rab.',
      discounted: 'Etter rab.',
      reverseReceived: 'Vil du reversere mottak av varer?'
    },
    stock: {
      onStock: 'På lager',
      onOrder: 'I bestilling',
      location: 'Lokasjon',
      warehouseLoc: 'Lager/Lokasjon',
      costPrice: 'Kostpris',
      onCustomerOrder: 'På kundeordre',
      importLocations: 'Importer lagerlokasjoner',
      toDeliver: 'Leveres'
    },
    ccsheet: {
      scannerLocation: 'Skann / søk etter lokasjon',
      searchLocation: 'Filtrer etter lokasjon',
      addCCSheet: 'Legg til CCSheet',
      updateCCSheet: 'Oppdater CCShett',
      ongoing: ' Pågående',
      onStock: 'På lager',
      counted: 'Telt',
      recount: 'Avvikstelling',
      completed: 'Telling fullført',
      completedAndAdjusted: 'Fullført og justert',
      useScanner: 'Bruk skanner',
      noProductsFound: 'Ingen produkt funnet',
      proceed: 'Forsette',
      scanProduct: 'Skann produkt',
      ccsheetReport: 'Telleskjema',
      completeSheet: 'Vil du lukke telleskjema?',
      countedTotal: 'Totalt telt',
      totalValues: 'Total verdi',
      diff: 'Diff',
      cannotPickAtThisWH: 'Telling er åpen for dette varenr. Ikke mulig å plukke nå.',
      quickCount: 'Telling av enkeltvarer',
      quick: 'Enkeltvare',
      itemsToCount: 'Hva skal telles',
      all: 'Alt',
      stockItems: 'Lagervarer',
      nonStockItems: 'Skaffevarer'
    },
    contact: {
      title: 'Tittel',
      contactLookupHeader: 'Kontaktinfo',
      nameExists: 'Kontakt eksisterer allerede',
      lookupModelHeader: 'Du har valgt å opprette en kontakt som eksisterer allerede. Vil du forsette?',
      telephoneMobileNumber: 'Telefon / mobil',
      hasBrreg: 'Brreg oppslag?',
      has1881: '1881 oppslag?'
    },
    orders: {
      salesReference: 'Saksnummer',
      addOrder: 'Legg til ordre',
      updateOrder: 'Oppdater ordre',
      contact: 'Kontakt',
      customercontact: 'Kundekontakt',
      deliveryAddress: 'Leveringsadresse',
      invoiceAddress: 'Fakturaadresse',
      invoiceTo: 'Faktura til',
      orderFor: 'Ordre kunde',
      ourReference: 'Vår referanse',
      yourReference: 'Deres referanse',
      offerInformation: 'Ordre informasjon',
      offerComments: 'Tilbud tekst og kommentarer',
      orderComments: 'Ordre tekst',
      standardSales: 'Standard salg',
      deliveryTerms: 'Leveringsvilkår',
      totalExVat: 'Totalt eks mva',
      totalSum: 'Sum totalt',
      productNo: 'Produktnr.',
      price: 'Pris',
      dataSheet: 'Datablad',
      searchForProduct: 'Søk etter produkt...',
      offerDate: 'Tilbudsdato',
      shipDate: 'Ut fra lager dato',
      offerDueDate: 'Gyldig til',
      orderDate: 'Ordredato',
      deliveryDate: 'Lev.dato',
      forProduction: 'Produksjon',
      pick: 'Plukk',
      forApproval: 'Til godkjenning',
      toInvoice: 'Til fakturering',
      invoiced: 'Fakturert',
      projectCompleted: 'Prosjekt avsluttet',
      cancelled: 'Kansellert',
      orderDetails: 'Ordre detaljer',
      materials: 'Materialer',
      billingData: 'Faktureringsdata',
      approve: 'Godkjenn',
      addNew: 'Ny',
      pQty: 'Plukket',
      user: 'Bruker',
      invoiceQty: 'Faktura antall',
      addNewProduct: 'Legg til vare',
      history: 'Historikk',
      createdBy: 'Laget av',
      lastUpdated: 'Sist oppdatert',
      billingTotalExVat: 'Fakturering totalt eks mva',
      offerPart: 'Tilbudslinjer',
      assignment: 'Oppdrag',
      tasksPerformed: 'Utført',
      packList: 'Pakkseddel',
      nvitPackList: 'NVIT pakkseddel',
      pickList: 'Plukkliste',
      proformaInvoice: 'Proforma Invoice',
      printLabels: 'Etiketter',
      orderHasBeenCreated: 'Ordre er allerede laget fra dette tilbudet. Vil du allikevel opprette en ny ordre?',
      customerOrder: 'Kunde/Leverandør',
      includeAllApprovedProduct: 'Vil du opprette faktura for alle godkjente varer?',
      productNotApprovedExclude: 'Varer uten godkjenning vil ikke bli inkludert i faktura. Vil du fortsette?',
      invoiceSelectRows: 'Minst en varelinje må være valgt',
      changesNotSaved: 'Endringene er ikke lagret. Vil du lagre og fortsette?',
      generateRestOrder: 'Ordre er ikke plukket ferdig. Vil du lage faktura og opprette restordre?',
      restOrderFor: 'Restordre for',
      restOrder: 'Restordre',
      storeSales: 'Salg i butikk',
      storeWeb: 'Butikk vs Nett',
      store: 'Butikk',
      web: 'Nett',
      totalInvoiced: 'Totalt fakturert',
      totalOrders: 'Totalt ordrer',
      stockAvailable: 'På lager',
      inBacklog: 'I backlog',
      standardOfferText: 'Standard tilbudstekst',
      standardOrderText: 'Standard ordretekst',
      standardDeliveryTerms: 'Standard betingelser',
      offerText: 'Tilbudstekst',
      orderText: 'Ordretekst',
      restQty: 'Rest ant.',
      unknown: 'Ukjent',
      archicad: 'Archicad import',
      zone: 'Sone',
      perzone: 'pr sone',
      existingDataOverwritten: 'Eksisterende data vil bli overskrevet. Vil du fortsette?',
      allDataOverwritten: 'Alle eksiterende verdier blir overskrevet!',
      discountForAllPrice: 'Vil du endre rabatt for alle varer?',
      contents: 'Innhold',
      noZone: 'Ingen sone',
      totalRows: 'Antall varer',
      stockablePackage: 'Lagerført',
      yourOrderNumber: 'Deres best.nr',
      salesDate: 'Salgsdato',
      salesValue: 'Salgsverdi',
      salenew: 'Forespørsel',
      sold: 'Solgt',
      lost: 'Tapt',
      createSales: 'Nytt salg',
      createSalesWithoutTemp: 'Nytt salg uten mal',
      sendFromWH: 'Sendeuke',
      installationWeek: 'Monteringsuke',
      installationCompleted: 'Montering utført',
      orderTotal: 'Ordresum',
      deliveryTime: 'Leveringstid',
      valuesCannotBeNegative: 'Kan ikke være negativ',
      invoiceComments: 'Faktura kommentar',
      totalAmountNegativeWarning: 'Totalt beløp er negativt. Vil du opprette kreditnota?',
      supplierNotSelectedOrder: 'Leverandør er ikke valgt for minst 1 linje. Vil du fortsette med å opprette leverandørordre?',
      customerDataChanged: 'Kundedata er endret. Vil du oppdatere eksisterende åpne tilbud og ordre?'
    },
    discountGrp: {
      customerGroup: 'Kundegrupper'
    },
    invoice: {
      saveAs: 'Opprett',
      saveAsDraft: 'Kladd',
      saveAndEmail: 'Faktura på epost',
      saveAndDownloadPDF: 'Faktura som PDF',
      saveAndUseEHF: 'Send EHF faktura',
      yourReference: 'Deres referanse',
      yourContact: 'Deres Kontakt',
      ourReference: 'Vår referanse',
      invoicedDate: 'Fakturadato',
      duedate: 'Forfall',
      invoicing: 'Fakturering',
      completedDate: 'Fullført dato',
      rbt: 'Rbt',
      sum: 'Sum',
      sumeksMva: 'Eks MVA',
      totalExVat: 'Sum u/MVA',
      MVA: 'MVA',
      roundDown: 'Runde ned',
      invoiceTotal: 'Faktura total inkl',
      invoicePreview: 'Forhåndsvisning',
      addInvoice: 'Legg til faktura',
      updateInvoice: 'Oppdater faktura',
      createCreditNote: 'Opprett kreditnota',
      updateCreditNote: 'Oppdater kreditnota',
      pmtTerms: 'Betalingsbetingelser',
      days: 'dager',
      exportToVisma: 'Eksporter til Visma',
      showAll: 'Vis alt',
      groupByCustomer: 'Grupper etter kunde',
      exported: 'Eksportert',
      totalSum: 'Totalt',
      cantDelete: 'Faktura kan ikke slettes!',
      toBeExported: 'Skal eksporteres',
      invoiceNumber: 'Fakturanr',
      basePrice: 'Grunnpris',
      priceIncVat: 'Inkl. Mva',
      invoiceCreatedBy: 'Faktura opprettet av',
      onDate: 'den',
      by: 'av',
      creditNoteCreatedBy: 'Kreditnota opprettet av',
      createdFrom: 'Opprettet fra',
      creditConfirm: 'Er du sikker på at du vil opprette kreditnota ?',
      confirmation: 'Bekreftelse',
      searchProduct: 'Søk Produkt',
      creditNote: 'Kreditnota',
      hoursConfirm: 'Det finnes timer som ikke er innlevert og/eller godkjent, vil du fortsette med opprettelse av faktura?',
      productsConfirm: 'Ingen varer er registrert på ordre, vil du fortsette med opprettelse av faktura?',
      hoursProducts: 'Ønsker du å ta med timer og produkter fra ordre?',
      qty: 'Antall',
      subject: 'E-post emne',
      body: 'E-post brødtekst',
      signature: 'E-post signatur',
      hoursProductAvail: 'Timer og/eller varer sal være tilgjengelig for fakturering?',
      pressHold: '* Trykk og hold <code>Ctrl</code> for å velge flere',
      prefixInvoiceNumber: 'faktura_nummer',
      resendEhf: 'Resend EHF',
      resendEmail: 'Send epost',
      standardInvoiceText: 'Standard faktura tekst',
      statusDraft: 'Utkast',
      statusProgress: 'I arbeid',
      statusSent: 'Sendt/Lastet ned',
      invoiceEmail: 'Faktura e-post',
      invoiceNotSaved: 'Faktura er ikke lagret. Vil du fortsette?',
      removeFromFixedPrice: 'Fjern fra fastprisgrunnlaget',
      deleteFromInvoice: 'Slett fra faktura',
      createAkonto: 'Ny Akonto faktura',
      newInvoice: 'Ny faktura',
      fixedPriceOnly: 'kun fastpris linje.',
      deleteWithArticles: 'slett med artikler',
      noItemsOnInvoice: 'Ingenting å fakturere. Vennligst legg til arbeid og produkter på fakturagrunnlaget!',
      draftExists: 'Det finnes allerede en fakturautkast. Vennligst fullfør eller slett den.',
      allInvoiced: 'Ordren er allerede fakturert.',
      noItemsOnOrder: 'No products found to create the supplier order!',
      xledger: 'xLedger',
      ehfSent: 'EHF sendt på nytt',
      ehfInfo: 'EHF faktura er sendt!',
      commercialInv: 'Commercial Inv.',
      invoicesCreated: 'Faktura(er) opprettet!',
      invoiceFailedtoSend: 'Faktura oppretter, men epost ble ikke sendt. Venligst last ned og send manuelt.',
      invoiceEHFFailed: 'EHF feilet. Feilen er rapportert.',
      statusOfInvoices: 'Fakturastatus',
      success: 'Opprettet',
      failed: 'Feilet',
      fullCredit: 'Kreditere hele',
      partialCredit: 'Del kreditere',
      abort: 'Avbryt',
      chooseorAbort: 'Velg type eller avbryt',
      selectProducts: 'Velg produkter',
      fullCreditContent: 'Krediter alle varer',
      partialCreditContent: 'Velg og krediter',
      resync: 'Resynk til 24seven',
      invoiceDownloadedBy: 'Faktura lastet ned av {user} den {date}',
      invoiceEmailedBy: 'Faktura sendt til {email} av {user} den {date}',
      invoiceEHFBy: 'EHF faktura opprettet av {user} den {date}',
      invoiceEHFResentBy: 'EHF sendt på nytt by {user} on {date}',
      creditNoteDownloadedBy: 'Kreditnota lastet ned av {user} den {date}',
      creditNoteEmailedBy: 'Kreditnota sendt til {email} av {user} den {date}',
      creditNoteEHFBy: 'EHF Kreditnota opprettet av {user} den {date}',
      cannotCreateInvoice: 'Faktura totalen bør være minst 1!',
      invoiceBody: 'Faktura standard epost tekst',
      creditBody: 'Kreditnota standard epost tekst',
      syncTo24seven: 'Synk 24seven',
      likeToSendEHF: 'Vil du sende faktura (som EHF) på nytt?'
    },
    settings: {
      addShipment: 'Legg til forsendelse',
      updateShipment: 'Oppdater forsendelse',
      addCustomerPriority: 'Legg til kundeprioritet',
      updateCustomerPriority: 'Oppdater kundeprioritet',
      addIndustry: 'Legg til kundebransje',
      updateIndustry: 'Oppdater kundebransje',
      addBuilding: 'Legg til anleggsadresse',
      updateBuilding: 'Oppdater anleggsadresse',
      shortName: 'Kort navn',
      addFacility: 'Legg til anleggsadresse',
      updateFacility: 'Oppdater anleggsadresse',
      addProductGroup: 'Legg til produktgruppe',
      updateProductGroup: 'Oppdater produktgruppe',
      equipmentType: 'Anleggstype',
      refrigerant: 'Kjølemiddel',
      refrigerantShort: 'Kuldem',
      addEquipmentType: 'Legg til anleggstype',
      updateEquipmentType: 'Oppdater anleggstype',
      addRefrigerant: 'Legg til kjølemedium',
      updateRefrigerant: 'Oppdater kjølemedium',
      addOrderType: 'Legg til ordretype',
      updateOrderType: 'Oppdater ordretype',
      order: 'Ordre',
      equipmentModel: 'Anleggsmodell',
      equipmentFabricate: 'Anleggsfrabrikat',
      equipmentDocuments: 'Anleggsdokumenter',
      industry: 'Industri',
      generalSettings: 'Firma informasjon',
      lockMsg: 'Timeføring låses den',
      monthMsg: 'i hver måned. Kan låses opp manuelt av administrator',
      minimumHours: 'Minimum antall timer per uke',
      organizationNumber: 'Organisasjonsnummer',
      sellerIndentificationCode: 'Selger identifikasjonskode',
      companyName: 'Selskapsnavn',
      accountNo: 'Kontonummer',
      ibanBban: 'IBAN / BBAN',
      branchName: 'SWIFT',
      vismaClientNumber: 'Visma klientnummer',
      streetName: 'Gatenavn',
      countryIdentityCode: 'Land identifikasjonskode',
      contactName: 'Kontakt navn',
      contactTelephone: 'Kontakt telefon',
      contactEmail: 'Kontakt e-post',
      companyInfo: 'Besøksadresse',
      postAddress: 'Postadresse',
      standardInvoiceText: 'Standard faktura tekst',
      category: 'Kategori',
      sendAutoReply: 'Send autosvar',
      autoReply: 'Autosvar',
      priceRecalculation: 'Alle priser som møter kriterier vil bli oppdatert'
    },
    unimicro: {
      pageTitle: 'Unimicro innstilling',
      customerNumber: 'Kundenummer',
      systemMailAddress: 'System postadressen',
      csvDelimiter: 'CSV skilletegn',
      createReport: 'Opprett rapport',
      updatedBy: 'Oppdatert av',
      updatedOn: 'Oppdatert på',
      preview: 'Forhåndsvis',
      employeeNumber: 'Ansatt nummer',
      salaryCode: 'Lønnskode',
      rate: 'Vurdere',
      accountNumber: 'UniMicro kontonummer',
      supplierNumber: 'leverandørnummer',
      payGrade: 'Lønnsnivå',
      organizationNumber: 'Org.nr',
      entryNo: 'Inngangsnummer',
      dim: 'Dim',
      numberToInvoice: 'Nummer til faktura',
      retailPrice: 'Utsalgspris',
      orderNumber: 'Ordrenummer',
      kommunenr: 'Kommunenr',
      createdBy: 'Laget av',
      createdOn: 'Opprettet den',
      datesMandatory: 'Datoer må velges',
      pending: 'Avventer',
      sent: 'Sendt',
      sendReport: 'Send rapport'
    },
    dashboard: {
      topCustomers: 'Toppliste',
      turnOverMonth: 'Fakturert denne mnd.',
      last: 'Siste',
      current: 'Denne',
      week: 'uken',
      month: 'måned',
      year: 'år'
    },
    invoiceReport: {
      line: 'Nummer',
      productDescription: 'Produkt beskrivelse',
      businessEnterprises: 'Foretaksregisteret',
      ourRef: 'Vår ref',
      yourRef: 'Deres ref',
      ourReference: 'Vår referanse',
      yourReference: 'Deres referanse',
      yourContact: 'Deres Kontakt',
      betBet: 'Bet.bet.',
      paymentTerms: 'Bet. betingelser',
      levBet: 'Lev.bet',
      deadline: 'Endrefrist',
      invoiceDate: 'Fakturadato',
      customerInfo: 'Kundeinfo',
      customerNo: 'Kunde nr',
      tel: 'Tlf',
      mobile: 'Mobil',
      telephone: 'Telefon',
      accNo: 'Kontonr',
      orderNo: 'Ordrenr',
      roundOff: 'Avrund',
      totalIncVat: 'Total inkl. mva.',
      kid: 'KID',
      amountToPay: 'Beløp å betale',
      paymentDeadline: 'Betalingsfrist',
      orgNo: 'Org. nr',
      saleRef: 'Saksnr',
      labeled: 'Merket'
    },
    userRole: {
      administrator: 'Administrator',
      office: 'Kontor',
      technician: 'Vanlig',
      technicians: 'Teknikere'
    },
    reports: {
      turnover: 'Omsetningsrapport',
      runReport: 'Kjør rapport',
      inventoryReport: 'Lagerverdirapport',
      totalInventoryValue: 'Verdi totalt',
      locations: 'Lokasjoner',
      vendor: 'Vendor',
      totalInventory: 'Verdi totalt',
      prodNo: 'Prod.nr',
      totalCosts: 'Sum kostnader',
      averageDG: 'Gjennomsnitt DG',
      monthUsage: 'Forbruk 12 mndr'
    },
    paymentTerm: {
      add: 'Legg til Bet. betingelser',
      update: 'Oppdater Bet. betingelser',
      enterNoOfDays: 'Antall dager'
    },
    deliveryTerm: {
      add: 'Legg til Leveringsbetingelser',
      update: 'Oppdater Leveringsbetingelser'
    },
    turnoverReport: {
      turnover: 'Omsetning',
      dg: 'DG',
      Groupby: 'Grupper',
      GroupbyYear: 'Grupper per år',
      GroupbyMonth: 'Grupper per måned',
      groupbycustomer: 'Grupper per kunde'
    },
    props: {
      new: 'Ny',
      name: 'Navn',
      description: 'Beskrivelse',
      label: 'Etikett',
      type: 'Type',
      placeholder: 'Plassholder',
      isActive: 'Er aktiv',
      actions: 'Handlinger',
      value: 'Verdi',
      properties: 'egenskaper',
      options: 'Alternativer',
      addProps: 'Legg til egenskaper',
      updateProps: 'Oppdater egenskaper',
      formAttributes: 'Skjema egenskaper',
      useAsTitle: 'Bruk som tittel',
      validation: 'Validering',
      isMultiSelect: 'Har flervalg',
      defaultValue: 'Standard verdi',
      enterValue: 'Angi en av verdiene fra alternativet',
      isApi: 'er API',
      apiUrl: 'API URL',
      objectName: 'Objektnavn',
      columns: 'Kolonner',
      gridColumns: 'Kolonner',
      question: 'Spørsmål?',
      link: 'Html',
      enterTitleOfColumn: 'Kolonnenavn',
      loadingGrid: 'Laster inn...',
      favourite: 'Favoritt',
      customProperties: 'Egendefinerte egenskaper',
      enterTitle: 'Skriv inn tittel',
      rows: 'Rader',
      preparingFields: 'Forbereder feltene',
      dragging: 'Dra ...',
      fontSize: 'Skriftstørrelse',
      preview: 'Forhåndsvisning',
      hideComments: 'Skjul kommentarer',
      hideAttachments: 'Skjul vedlegg',
      defaultValueKeyword: 'Standardverdi etter søkeord',
      setCurrentUserAsDefault: 'Set innlogget bruker som standard',
      rowsToAutoCreate: 'Automatisk genererte linjer',
      showInNextRow: 'Vis på neste linje',
      addTopSpace: 'Legg til plass.',
      optionsValuesAreNotUnique: 'Valgene må være unike. ',
      viewType: 'Vis type',
      showWidthField: 'Vis feltbredde over Header',
      enterTitleAndWidthOfColumn: 'Skriv tittel i kolonnebredde (1-12)',
      fieldInfo: 'Felt info',
      valueForCalculation: 'Verdi for beregning.',
      customFieldsNotAvailable: 'Felt er ikke tilgjengelig. ',
      selectStatus: 'Velg status',
      template: 'Mal',
      drag: 'Dra',
      showSum: 'Vis totalen',
      moduleFields: 'Modul felter (Tittel: Placeholder)',
      placeHolderUsageMessage: 'Bruke plassholdere mellom {} i maler. F.eks.: {Name}'
    },
    form: {
      updateFormProps: 'Oppdater skjema',
      addNewForm: 'Legg til ny skjema',
      selectGroup: 'Velg gruppe',
      addHeader: 'Legg til Header',
      addFooter: 'Legg til Footer',
      formProps: 'Skjemaegenskaper',
      allCaughtUp: 'Lest alle oppdatering',
      dropFields: 'Slipp feltene her!',
      addHtmlContent: 'Legg til HTML innhold',
      forHeader: 'Overskrift',
      forFooter: 'Bunntekst',
      comments: 'Kommentar',
      attachments: 'Vedlegg',
      sureToCloneFields: 'Er du sikker på at du vil klone feltet?',
      documents: 'Dokumenter',
      document: 'Dokument',
      updateDocument: 'Oppdater dokument',
      addGroup: 'Legg til gruppe',
      updateGroup: 'Oppdater gruppe',
      date: 'Dato',
      signature: 'Signatur'
    },
    checklist: {
      addChecklist: 'Ny sjekkliste',
      updateChecklist: 'Oppdater sjekkliste',
      sendChecklist: 'Send sjekkliste'
    },
    documents: {
      documentSignature: 'Dokument signatur',
      emailMessage: 'Epost melding',
      invitationValidTill: 'Invitasjon er gyldig til',
      emailDocumentsAfterSigning: 'Send dokumenter etter signering',
      signeeShouldReadDocument: 'Krev lesing av dokumentet',
      signers: 'Signatur',
      allowSigningWithoutStrongAuthentication: 'Tillat signering uten sterk innlogging',
      signAsOrganization: 'Signer som firma',
      notifyInviteesWhenEveryoneHasSigned: 'Varsle når alle har signert',
      reminderDate: 'Påminnelse',
      signInSpecifiedOrder: 'Signer i spesifisert rekkefølge',
      validityTime: 'Gyldig i',
      signatureType: 'Signatur type',
      withoutStrongAuthentication: 'Without strong authentication',
      strongAuthentication: 'Strong authentication'
    }
  }
}
